import { consumerRoot, isConsumer } from 'src/config'
import Model from 'src/models/model'
import DynamicConsumerLayout from 'src/modules/consumer/layouts/DynamicConsumerLayout'
import { buildConsumerChildRoutes } from 'src/modules/consumer/routes'
import { addMissingCurrentSitePathPrefix, addOrRemoveCanonicalLinkTag, switchToRequiredSite, switchToRootPrimarySiteIfForced } from 'src/router/guards'
import { prependWithConsumerRoot } from 'src/router/utils'

export default async ({ router }) => {
  if (!isConsumer) return

  await Model.configuration.ensureLoaded()

  router.beforeEach(addOrRemoveCanonicalLinkTag) // for SEO

  // Assumes the currentSite at boot time matches config.siteId
  const defaultSite = Model.configuration.currentSite
  const isHostnameSharedAcrossSites = defaultSite.isHostnameSharedAcrossSites
  const sharedDomainSitesByPath = defaultSite.sharedHostnameSiteIdsByPath

  // Helper function to build same set of consumer routes multiple times, for the default
  // site and for any other sites that share the same hostname
  function buildNamespacedRootRoute (namespace, siteId, siteRootPath) {
    const rootRoute = {
      path: siteRootPath === consumerRoot ? consumerRoot : prependWithConsumerRoot(siteRootPath),
      // DynamicConsumerLayout lazy loads and renders layouts based on the $route.meta.layout
      component: DynamicConsumerLayout,
      // Child routes inherit their parent route's meta fields but can override them
      meta: { layout: 'ConsumerLayout' },
      children: buildConsumerChildRoutes(namespace)
    }

    if (isHostnameSharedAcrossSites) {
      // `meta.requiredSiteId` is used by the `switchToRequiredSite` guard to determine which site to switch to
      // when the user navigates to this route and its child routes.
      rootRoute.meta.requiredSiteId = siteId

      _.each(rootRoute.children, route => {
        route.beforeEnter = _([
          switchToRootPrimarySiteIfForced,
          addMissingCurrentSitePathPrefix,
          switchToRequiredSite,
          route.beforeEnter
        ]).flatten().compact().value()
      })
    }

    return rootRoute
  }

  /**
   * Set consumer routes
   */

  router.addRoute(buildNamespacedRootRoute('consumer', defaultSite.id, consumerRoot))

  if (isHostnameSharedAcrossSites) {
    _.each(sharedDomainSitesByPath, (siteId, siteRootPath) => {
      router.addRoute(buildNamespacedRootRoute(`consumer:site-${siteId}`, siteId, siteRootPath))
    })
  }

  if (isConsumer) {
    router.addRoute({ name: 'app:root', redirect: { name: 'consumer:root' } })
  }
}
